








// @ is an alias to /src
import Login from "@/components/LoginForm.vue";
import { Component, Vue } from "vue-property-decorator";
import { Route } from "@rocketbase/vue-extra-decorators";
import TopToolbar from "@/components/TopToolbar.vue";

@Route({
  path: "/authentication/login"
})
@Component({
  components: { TopToolbar, Login }
})
export default class LoginPage extends Vue {
  private showMenu = false;

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }
}
